import React from "react";
import { getPercentage } from "../../../../../../../Common/FewCommonMethods";
import { Commas } from "../../../../../../../Common/AllDateTimeReleventFormate";

export default function PaymentInfo({
  posts,
  proposalmilestones,
}) {
  const AmountPaid =
    proposalmilestones?.milestones
      ?.filter((milestone) => milestone.status == "5")
      .reduce((acc, milestone) => acc + parseFloat(milestone.amount), 0) || 0;

  // Calculate AmountinEscrow
  const AmountinEscrow =
    proposalmilestones?.milestones
      ?.filter((milestone) => ["2", "3", "4"].includes(milestone.status))
      .reduce((acc, milestone) => acc + parseFloat(milestone.amount), 0) || 0;

  // Calculate Projectprice
  const Projectprice =
    proposalmilestones?.milestones
      ?.filter((milestone) =>
        ["1", "2", "3", "4", "5"].includes(milestone.status),
      )
      .reduce((acc, milestone) => acc + parseFloat(milestone.amount), 0) || 0;

  const percentage = getPercentage(Projectprice, AmountPaid);

  return (
    <div className="col-md-4">
      <div className="payment-info">
        <h6>Payment info</h6>
        <div className="progress">
          <div
            className="progress-bar"
            role="progressbar"
            style={{ width: `${percentage}%` }}
            aria-valuenow="25"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <div className="amountpaid-p">
          <div className="amount">
            <p>{posts?.is_mine == 1 ? "Amount Paid" : "Amount Received"}</p>
            <p>$ {Commas(AmountPaid)}</p>
          </div>
          <div className="amountpaid-p">
            <div className="amount">
              <p>Amount In Escrow</p>
              <p>$ {Commas(AmountinEscrow)}</p>
            </div>
          </div>
          <div className="amountpaid-p">
            <div className="amount">
              <p>Project price</p>
              <p>$ {Commas(Projectprice)}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
